export const NEWSLETTER_FORM_URL = "http://eepurl.com/hWcRyH";
